export default "__VITE_ASSET__Dr87pvRL__"